import * as React from 'react';
import classNames from 'classnames';
import 'react-autosuggest';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import 'tslib';
import { NvMarkdownInline, NvSubheading } from '@invitae/ids-react';
import '../../common/VideoPopupLink/VideoPopup/VideoPopup.esm.js';
import '@invitae/add-to-cart';
import '@invitae/nucleobase-engine-contentful';
import '../../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import '@invitae/nucleobase-analytics';
import '../../common/ContentfulImage/ContentfulImage.esm.js';
import '../../hooks/animation/animationContext.esm.js';
import '../../hooks/animation/classManipulation.esm.js';
import '../../types/animation.esm.js';
import '../../common/ContentfulImage/ImageContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import '../../common/WrappedVideo/NvVideo/NvVideo.esm.js';
import '../../common/WrappedVideo/Vimeo/Vimeo.esm.js';
import 'react-dom';
import 'luxon';
import 'use-debounce';
import '../../GlobalTextCopyContext/GlobalTextCopyContext.esm.js';
import styles from './ListOfLinksBlock.module.esm.js';

var ListOfLinksBlock = function (_a) {
    var _b = _a.fields, internalName = _b.internalName, heading = _b.heading, subheading = _b.subheading, items = _b.items, footer = _b.footer, id = _a.id, dataCy = _a["data-cy"];
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(styles.container, 'nv-container'), "data-cy": dataCy, id: id, sectionName: internalName },
        !!heading && React.createElement(BaseHeading, { className: styles.heading, heading: heading, headingAlignment: "left" }),
        !!subheading && (React.createElement(NvMarkdownInline, { elementWrapper: NvSubheading, level: "level1book" }, subheading)),
        React.createElement("div", null, items.map(function (sectionItem) { return (React.createElement(BaseNucleobaseComponent, { key: sectionItem.sys.id, source: sectionItem })); })),
        footer && React.createElement(BaseNucleobaseComponent, { source: footer })));
};

export { ListOfLinksBlock as default };
//# sourceMappingURL=ListOfLinksBlock.esm.js.map
